import { rootApi } from '../../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['LocationType'],
});

export const locationTypeApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllLocationTypes: builder.query({
      query: () => `location_types/`,
      providesTags: ['LocationType'],
    }),
    findLocationTypeById: builder.query({
      query: (id) => `location_types/${id}/`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'LocationType', id: result.id }]
          : ['LocationType'];
      },
    }),
    createLocationType: builder.mutation({
      query: (locationType) => ({
        url: `location_types/`,
        method: 'POST',
        body: locationType,
      }),
      invalidatesTags: ['LocationType'],
    }),
    updateLocationType: builder.mutation({
      query: (locationType) => ({
        url: `location_types/${locationType.id}/`,
        method: 'PATCH',
        body: locationType,
      }),
      invalidatesTags: ['LocationType'],
    }),
    deleteLocationType: builder.mutation({
      query: (locationType) => ({
        url: `location_types/${locationType.id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['LocationType'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllLocationTypesQuery,
  useFindLocationTypeByIdQuery,
  useCreateLocationTypeMutation,
  useUpdateLocationTypeMutation,
  useDeleteLocationTypeMutation,
} = locationTypeApi;
